import { render, staticRenderFns } from "./socheckrecord.vue?vue&type=template&id=7f6fac30&scoped=true&"
import script from "./socheckrecord.vue?vue&type=script&lang=js&"
export * from "./socheckrecord.vue?vue&type=script&lang=js&"
import style0 from "./socheckrecord.vue?vue&type=style&index=0&id=7f6fac30&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6fac30",
  null
  
)

export default component.exports